<template>
  <div class="main after-star transprent-form-h5 h5-wrap">
    <img class="title-img" src="https://v1-static.oss-cn-zhangjiakou.aliyuncs.com/image/drainage-title.png" alt="">
    <p class="mask">请填写以下资料，立即开通试用账号，我们会尽快与您联系</p>
    <el-form :model="ruleForm" :rules="rules" label-position="top" ref="ruleForm">
      <el-form-item label="企业名称" prop="organization_name">
        <el-input v-model="ruleForm.organization_name" placeholder="请输入您所在的企业名称"></el-input>
      </el-form-item>
      <el-form-item label="联系人" prop="contacts">
        <el-input v-model="ruleForm.contacts" placeholder="请输入联系人姓名"></el-input>
      </el-form-item>
      <el-form-item label="手机号码" prop="phone_number">
        <el-input v-model="ruleForm.phone_number" placeholder="请输入联系人的手机号码"></el-input>
      </el-form-item>
      <el-form-item label="企业所属行业" prop="industry">
        <el-select v-model="ruleForm.industry" placeholder="请选择企业所属行业">
          <el-option
            v-for="(value, key) in industryList"
            :key="key"
            :label="value"
            :value="key">
          </el-option>
        </el-select>
      </el-form-item>
      <el-form-item label="企业所在地" prop="district_code">
        <el-select v-model="ruleForm.district_code" placeholder="请选择企业所在省份">
          <el-option
            v-for="item in provinceList"
            :key="item.province_code"
            :label="item.province_name"
            :value="item.province_code">
          </el-option>
        </el-select>
      </el-form-item>
      <el-form-item label="企业人员规模" prop="scale">
        <el-select v-model="ruleForm.scale" placeholder="请选择企业人员规模">
          <el-option
            v-for="(value, key) in dimensionsList"
            :key="key"
            :label="value"
            :value="key">
          </el-option>
        </el-select>
      </el-form-item>
      <el-form-item label="需要测温一体机数量" prop="required_number">
        <el-input v-model.number="ruleForm.required_number" placeholder="请输入需要测温一体机的数量"></el-input>
      </el-form-item>
      <el-form-item label="备注">
        <el-input type="textarea" v-model="ruleForm.remarks"></el-input>
      </el-form-item>
      <el-form-item>
        <el-checkbox v-model="ruleForm.is_agency">我是代理商</el-checkbox>
      </el-form-item>
      <el-form-item>
        <el-button class="button" type="primary" :loading="loading" @click="submitForm('ruleForm')">提交信息</el-button>
      </el-form-item>
    </el-form>
  </div>
</template>
<script>
export default {
  name: 'DrainagePage',
  data() {
    return {
      miniapp: false,
      loading: false,
      industryList:{},
      dimensionsList:{},
      provinceList:[],
      cityList:[],
      ruleForm: {
        organization_name: '',
        contacts: '',
        phone_number: '',
        industry: '',
        district_code: '',
        scale: '',
        required_number: '',
        remarks: ''
      },
      rules: {
        organization_name: [
          { required: true, message: '请输入您所在的企业名称', trigger: 'blur' }
        ],
        contacts: [
          { required: true, message: '请输入联系人姓名', trigger: 'blur' }
        ],
        phone_number: [
          { required: true, message: '请输入联系人的手机号码', trigger: 'blur' },
          { pattern: /^\d{11}$/, message: '手机号码格式错误', trigger: 'blur' }
        ],
        industry: [
          { required: true, message: '请选择企业所属行业', trigger: 'change' }
        ],
        province: [
          { required: true, message: '请选择企业所在省份', trigger: 'change' }
        ],
        district_code: [
          { required: true, message: '请选择企业所在市区', trigger: 'change' }
        ],
        scale: [
          { required: true, message: '请选择企业人员规模', trigger: 'change' }
        ],
        required_number: [
          // { required: true, message: '请输入需要测温一体机的数量', trigger: 'blur' },
          { pattern: /^\d*$/, message: '数量只能是不小于0的数字', trigger: 'blur' }
        ]
      }
    }
  },
  created() {
    this.getDictList()
    this.getProvinceList()
    this.miniapp = this.$router.history.current.query.miniapp === 'true'
  },
  methods: {
    getDictList() {
      this.axios.get('application/dict').then(r => {
        if(r.data.code === 200) {
          let data = r.data.data;
          this.industryList = data.INDUSTRY_DICT
          this.dimensionsList = data.SCALE_DICT
        } else {
          this.$message({
            message: r.data.msg || '服务异常',
            type: 'error',
            customClass: 'message-style'
          })
        }
      }).catch( err => {
        console.log(err)
      })
    },
    getProvinceList() {
      this.axios.get('district/province').then(r => {
        if(r.data.code === 200) {
          let data = r.data.data;
          this.provinceList = data.list
        } else {
          this.$message({
            message: r.data.msg || '服务异常',
            type: 'error',
            customClass: 'message-style'
          })
        }
      }).catch( err => {
        console.log(err)
      })
    },
    submitForm(formName) {
      this.$refs[formName].validate((valid) => {
        if (valid) {
          let condition = JSON.parse(JSON.stringify(this.ruleForm));
          let province = this.provinceList.find(v =>{
            return v.province_code === condition.district_code
          });
          condition.province_name = province.province_name;
          condition.industry = +condition.industry;
          condition.scale = +condition.scale;
          condition.required_number = +condition.required_number;

          this.loading = true;
          this.axios.post(`application/submit`, condition).then(r => {
            this.loading = false;
            if(r.data.code === 200){
              localStorage.setItem('salesman',JSON.stringify(r.data.data));
              this.$router.replace(`/h5/success?type=experience&miniapp=${this.miniapp}`)
            } else {
              this.$message({
                type: 'error',
                message: r.data.msg,
                customClass: 'message-style'
              });
            }
          }).catch( err => {
            console.log(err)
            this.loading = false
            this.$message({
              message: err || '服务异常',
              type: 'error',
              customClass: 'message-style'
            })
          })
        } else {
          console.log('error submit!!');
          return false;
        }
      });
    }
  }
}
</script>

<style scoped lang="scss">
.main {
  background: url('https://v1-static.oss-cn-zhangjiakou.aliyuncs.com/image/bg.png') no-repeat center top / 100% 100%;
  padding: .4rem .18rem .2rem;
  .title-img {
    display: block;
    width: 3rem;
    margin: 0 auto;
  }
  .mask {
    margin: .08rem 0 .24rem;
    text-align: center;
    font-size: .12rem;
    color: rgba(255,255,255,.7);
  }
  .el-form-item {
    margin-bottom: .2rem;
  }
  .el-select {
    width: 100%;
  }
  .button {
    height: .5rem;
    width: 100%;
  }
}
</style>
<style lang="scss">
  .transprent-form-h5.after-star {
    .el-form-item.is-required:not(.is-no-asterisk)>.el-form-item__label:after {
      content: '*';
      color: #F56C6C;
      margin-left: 5px;
    }
  }
</style>